import { ApiServiceHelper } from '../crud-helpers'

import { EVENTS } from '@/store/actions/events'

export const EventsHelper = {
    list(params) {
        return ApiServiceHelper.execAction(EVENTS.LIST, params)
    },
}
